import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { IAggregatorReferralsCommission } from '../../../types/commission';
import { RootState } from '../..';

export interface IGetSecondaryReferralsCommissionsResponse {
  status?: boolean;
  message?: string;
  data?: {
    transactions?: IAggregatorReferralsCommission[];
    page: number;
    dataSize: number;
    total: number;
  };
  meta?: {
    perPage?: number;
    totalPages?: number;
    total?: number;
    page?: number;
  };
  errors?: IApiResponseError;
}

const initialState: IApiState<IGetSecondaryReferralsCommissionsResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const getSecondaryReferralsCommissionsAsync = createAsyncThunk(
  'secondaryReferralsCommissions/get',
  async (commissionNumber: string, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;
      const businessId = localStorage.getItem('businessId');

      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
          'X-Business-Id': businessId,
        },
      };

      const { data } = await api.get(
        `/commission/transactions/aggregators/${commissionNumber}?channel=merchant_retail`,
        config
      );

      return data;
    } catch (err) {
      const error =
        err as AxiosError<IGetSecondaryReferralsCommissionsResponse>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const secondaryReferralsCommissionsFetch = createSlice({
  name: 'secondaryReferralsCommissions/fetch',
  initialState,
  reducers: {
    resetSecondaryReferralsCommissions: (state) => {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSecondaryReferralsCommissionsAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(
        getSecondaryReferralsCommissionsAsync.fulfilled,
        (state, action) => {
          state.status = 'success';
          state.value =
            action.payload as IGetSecondaryReferralsCommissionsResponse;
        }
      )
      .addCase(
        getSecondaryReferralsCommissionsAsync.rejected,
        (state, action) => {
          state.status = 'failed';
          state.value =
            action.payload as IGetSecondaryReferralsCommissionsResponse;
          state.error = action.error.message;
        }
      );
  },
});

export const { resetSecondaryReferralsCommissions } =
  secondaryReferralsCommissionsFetch.actions;
export default secondaryReferralsCommissionsFetch.reducer;
